import React from 'react'

import './Divider.css'

const Divider =(props)=> {
  return (<div className="divider"/>)
}

export default Divider